import { defineMessages } from 'react-intl';

export default defineMessages({
  row: {
    id: 'Row',
    defaultMessage: 'Row',
  },
  cutRow: {
    id: 'Cut row',
    defaultMessage: 'Cut row',
  },
  pasteRowBefore: {
    id: 'Paste row before',
    defaultMessage: 'Paste row before',
  },
  pasteRowAfter: {
    id: 'Paste row after',
    defaultMessage: 'Paste row after',
  },
  addImage: {
    id: 'Add image',
    defaultMessage: 'Add image',
  },
  titleBlock: {
    id: 'Table block',
    defaultMessage: 'Table block',
  },
  hideHeaders: {
    id: 'Hide headers',
    defaultMessage: 'Hide headers',
  },
  sortable: {
    id: 'Make the table sortable',
    defaultMessage: 'Make the table sortable',
  },
  sortableDescription: {
    id: 'Visible only in view mode',
    defaultMessage: 'Visible only in view mode',
  },
  fixed: {
    id: 'Fixed width table cells',
    defaultMessage: 'Fixed width table cells',
  },
  compact: {
    id: 'Make the table compact',
    defaultMessage: 'Make the table compact',
  },
  basic: {
    id: 'Reduce complexity',
    defaultMessage: 'Reduce complexity',
  },
  // celled: {
  //   id: 'Divide each row into separate cells',
  //   defaultMessage: 'Divide each row into separate cells',
  // },
  // inverted: {
  //   id: 'Table color inverted',
  //   defaultMessage: 'Table color inverted',
  // },
  striped: {
    id: 'Stripe alternate rows with color',
    defaultMessage: 'Stripe alternate rows with color',
  },
  tableTitle: {
    id: 'Table title',
    defaultMessage: 'Table title',
  },
  tableTitleDescription: {
    id: 'Provide a descriptive title for the table. This text is used by screen readers.',
    defaultMessage:
      'Provide a descriptive title for the table. This text is used by screen readers.',
  },
  showTitle: {
    id: 'Show table title',
    defaultMessage: 'Show table title',
  },
});
